import { useSelector } from "react-redux";
import { StateTypes } from "../model/data";

const useFeatureFlags = () => {
  const feature_flags = useSelector((s: StateTypes) => s.user.feature_flags);
  return feature_flags;
};

export default useFeatureFlags;